import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { NewsChatButton } from '../../../buttons/iconButtons/other/ChatCollection';
import styles from './FloatingChatButton.module.scss';

interface FloatingChatButtonProps {
    unreadCount: number;
    onClick: () => void;
    isOpen?: boolean;
}

const FloatingChatButton: React.FC<FloatingChatButtonProps> = ({ 
    unreadCount, 
    onClick, 
    isOpen = false 
}) => {

    const { t } = useTranslation();
    const baseT = (value: string) => t('chat.' + value);
    const isUnReadNews = unreadCount > 0

    return (
        <>
            <div
                className={`${styles.buttonContainer} ${isOpen ? styles.open : ''} ${isUnReadNews ? styles.unReadNews : ''} `}
            >
                <div onClick={onClick} className={styles.buttonWrapper}>
                    <div className={styles.buttonIndicator} />
                    <Tooltip
                        title={baseT('chatTooltip')}                       
                        placement="top"
                        getPopupContainer={() => document.body}    
                    >
                        <div>
                            <NewsChatButton sizeVariant='big' count={unreadCount} />
                        </div>
                    </Tooltip>
                </div>
            </div>
        </>
    );
};

export default FloatingChatButton;